import { Keyword } from "./keyword";

export class NewsfeedKeyword {
    id: number;
    keyword_id: number;
    keyword: Keyword;
    column: number;
    newsfeed_id: number;

    /**
     * constructor
     *
     * @param {NewsfeedKeyword} init
     */
    public constructor(init?: NewsfeedKeyword)
    {
        if (!!init)
        {
            Object.assign(this, init);

            // initiate keyword
            this.keyword = new Keyword(this.keyword);
        }
    }
}
